import { useSelector } from 'react-redux';
import { RootState } from 'Store/index';

export default function useMasterCurrency() {
	const metadata = useSelector((state: RootState) => state.App.metadata);
	const masterCurrency = metadata?.customerCurrencies.find(c => c.masterCurrency);
	return masterCurrency;
}
